import getCdnUrl from '../../../helpers/get-cdn-url';

const SatLogo = getCdnUrl('/common_assets/assets/images/sat_logo.png');

export default SatLogo;
